import { render, staticRenderFns } from "./MainFilter.vue?vue&type=template&id=3c6c996e"
import script from "./MainFilter.vue?vue&type=script&lang=js"
export * from "./MainFilter.vue?vue&type=script&lang=js"
import style0 from "./MainFilter.vue?vue&type=style&index=0&id=3c6c996e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports